var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "envelope"), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    height: 346,
    id: "svg_1",
    width: 463,
    x: 25,
    y: 81
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464,64l-416,0c-26.5,0 -48,21.5 -48,48l0,288c0,26.5 21.5,48 48,48l416,0c26.5,0 48,-21.5 48,-48l0,-288c0,-26.5 -21.5,-48 -48,-48zm-416,32l416,0c8.8,0 16,7.2 16,16l0,41.4c-21.9,18.5 -53.2,44 -150.6,121.3c-16.9,13.4 -50.2,45.7 -73.4,45.3c-23.2,0.4 -56.6,-31.9 -73.4,-45.3c-97.4,-77.3 -128.7,-102.8 -150.6,-121.3l0,-41.4c0,-8.8 7.2,-16 16,-16zm416,320l-416,0c-8.8,0 -16,-7.2 -16,-16l0,-205c22.8,18.7 58.8,47.6 130.7,104.7c20.5,16.4 56.7,52.5 93.3,52.3c36.4,0.3 72.3,-35.5 93.3,-52.3c71.9,-57.1 107.9,-86 130.7,-104.7l0,205c0,8.8 -7.2,16 -16,16z",
    fill: "#3d3d3d",
    id: "svg_2",
    transform: "matrix(1 0 0 1 0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.a12a4d3b72733f0ee3c8a08781769d2f.svg";
export { ForwardRef as ReactComponent };